import type { LibericaLeftBlock, Button } from "src/components/organisms/LibericaFree/LibericaFree";
import {LibericaLiItem} from "src/components/organisms/LibericaFree/LibericaFree";

export const LeftBlock: LibericaLeftBlock = {
  hText: "Download Liberica Native Image Kit now for Free",
  pText:
    "Find binaries to build Docker containers that can be used to compile GraalVM source files in just a few clicks for native image users. Start building performant and secure native images today!",
};

export const Buttons: Button[] = [
  {
    className: 'bg-pink color-white',
    linkText: "Download",
    linkUrl: "/pages/downloads/native-image-kit/",
  },
];

export const Items: LibericaLiItem[] = [
];
